function pinChange(){
    let index = $(this).data('pin');
    if($(this).val()) {
        $(`.pin[data-pin="${index + 1}"]`).focus();
    }else{
        $(`.pin[data-pin="${index - 1}"]`).focus();
    }
};

$('.pin').keyup(pinChange);
